export const APP_ROUTES = {
  ROOT: '',
  LOGIN: 'login',
  REGISTER: 'register',
  SSOLOGIN: 'ssologin',
  PWDRESET: 'pwdreset',
};
